import { Shield, Eye, Brain, PenTool, Heart, ArrowDown } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { EXAM_MINDSET, EXAM_RESET, IMAGES } from "@/data/content";

const ICONS = { rhino: Shield, eagle: Eye, brain: Brain, hand: PenTool, heart: Heart };

const ExamPrep = () => (
  <section id="exam-prep" data-testid="exam-prep-section" className="relative py-20 lg:py-28 bg-inavy overflow-hidden scroll-mt-24">
    <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-sky-500/20 blur-3xl" />
    <div className="pointer-events-none absolute bottom-0 -left-24 h-80 w-80 rounded-full bg-brand/30 blur-3xl" />

    <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
      <SectionHeading
        dark
        align="center"
        eyebrow="Exam Preparation"
        title="The IQMIZE Exam Mindset"
        description={'"I don’t have to fight the examination. I only have to show what I know."'}
      />

      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5" data-testid="exam-mindset-grid">
        {EXAM_MINDSET.map((m, i) => {
          const Icon = ICONS[m.icon];
          return (
            <Reveal key={m.title} delay={i * 0.07}>
              <div
                data-testid={`exam-mindset-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="h-full rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 text-center transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-white/10"
              >
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-igold text-slate-900">
                  <Icon size={24} strokeWidth={1.8} />
                </div>
                <h3 className="mt-4 text-base font-bold uppercase tracking-wide text-white">{m.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-sky-100/80">{m.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div className="mt-20 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-sm p-3">
            <img
              src={IMAGES.exam}
              alt="Student writing an exam with focus"
              data-testid="exam-image"
              className="w-full h-[300px] md:h-[380px] object-cover rounded-2xl bg-inavy-dark"
              loading="lazy"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div data-testid="exam-reset-card" className="rounded-3xl bg-white p-8 lg:p-10 shadow-2xl">
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-brand">When nerves hit</p>
            <h3 className="mt-3 text-2xl font-bold tracking-tight text-slate-900">The 5-Minute Exam Reset</h3>
            <div className="mt-7 space-y-0">
              {EXAM_RESET.map((step, i) => (
                <div key={step} className="flex flex-col items-start">
                  <div className="flex items-center gap-4">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-extrabold ${i === 0 ? "bg-igold text-slate-900" : "bg-brand-light text-brand"}`}>
                      {i + 1}
                    </span>
                    <p className="text-sm md:text-base font-bold text-slate-800">{step}</p>
                  </div>
                  {i < EXAM_RESET.length - 1 && (
                    <ArrowDown size={14} className="ml-2.5 my-1 text-slate-300" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default ExamPrep;
